var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExamplesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2379_48180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.005 18.4182C15.9967 18.4182 18.4221 15.9928 18.4221 13.0011C18.4221 10.0093 15.9967 7.58398 13.005 7.58398C10.0132 7.58398 7.58789 10.0093 7.58789 13.0011C7.58789 15.9928 10.0132 18.4182 13.005 18.4182Z",
    stroke: "black",
    strokeWidth: 1.62513,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0029 1.08398V3.25082",
    stroke: "black",
    strokeWidth: 1.62513,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0029 22.752V24.9188",
    stroke: "black",
    strokeWidth: 1.62513,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.57422 4.57227L6.11267 6.11072",
    stroke: "black",
    strokeWidth: 1.62513,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8926 19.8926L21.431 21.431",
    stroke: "black",
    strokeWidth: 1.62513,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.08594 13.002H3.25277",
    stroke: "black",
    strokeWidth: 1.62513,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7549 13.002H24.9217",
    stroke: "black",
    strokeWidth: 1.62513,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.57422 21.431L6.11267 19.8926",
    stroke: "black",
    strokeWidth: 1.62513,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8926 6.11072L21.431 4.57227",
    stroke: "black",
    strokeWidth: 1.62513,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2379_48180"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.002,
    height: 26.002,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExamplesIcon);
export default __webpack_public_path__ + "static/media/examples-icon.71002e0b6c4ce5fdddad6bbb828cfcdb.svg";
export { ForwardRef as ReactComponent };